import { useLang } from 'hooks/lang';

import { calculateProjectTotal } from 'entities';

import { Card, Column, Row } from 'components/Blocks';
import { PropertyWithIcon } from 'components/PropertyWithIcon';
import {
  CreditCardIcon,
  ChatIcon,
  BadgeDollarIcon,
  HandCoinsIcon,
  PackageCheckIcon,
  ReceiptLongIcon,
} from 'components/Icons';

import { InvoiceControlMenu } from './Menu';
import { ChangePayment } from './ChangeType';
import { MinFee } from './MinFee';
import { MarkAsPaid } from './MarkAsPaid';
import { FreshDeskTickets } from './FreshDeskTickets';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';

import { calculateAvailableAmount } from '../utils';
import { formatCurrency, capitalize } from 'utils/text';

export function PaymentInfo() {
  const { project } = useProjectProfile();

  const { invoice } = project;

  const { t } = useLang();

  return (
    <Card flow="column">
      <Row justifyContent="space-between">
        <h6>{t('information')}</h6>

        <InvoiceControlMenu />
      </Row>

      <Column>
        <PropertyWithIcon
          containerClassName="phone:flex-col"
          icon={<BadgeDollarIcon />}
          name={t('amount-available')}
          value={
            <Row gap="2">
              <span className="text-success">{project.currency}</span>

              <span className="text-primary">
                {formatCurrency(calculateAvailableAmount(project))} /{' '}
                {formatCurrency(calculateProjectTotal(project.services))}
              </span>

              <MarkAsPaid />
            </Row>
          }
        />

        <MinFee />

        <PropertyWithIcon
          icon={<HandCoinsIcon />}
          name={t('payment-type')}
          alignItems="center"
          value={
            <Row gap="2">
              {invoice.type &&
                (invoice.type === 'PACKAGE' ? <PackageCheckIcon /> : <ReceiptLongIcon />)}

              <span>{capitalize(invoice.type || '')}</span>

              <ChangePayment />
            </Row>
          }
        />

        {invoice.typeConfig?.installments && (
          <PropertyWithIcon
            icon={<CreditCardIcon />}
            name={t('installments')}
            value={invoice.typeConfig?.installments}
          />
        )}
      </Column>

      <FreshDeskTickets />

      <Column>
        <PropertyWithIcon icon={<ChatIcon />} name={t('commentary')} value={''} />

        <p className="break-words rounded-md border bg-muted p-3 italic">
          {invoice.typeConfig?.comment || 'N/A'}
        </p>
      </Column>

      {!!invoice.sentToInvoiceComment && (
        <Column>
          <PropertyWithIcon
            icon={<ChatIcon />}
            name={t('comment-added-when-sent-to-invoice')}
            value={''}
          />

          <p className="break-words rounded-md border bg-muted p-3 italic">
            {invoice.sentToInvoiceComment}
          </p>
        </Column>
      )}
    </Card>
  );
}
